import PaymentModalModule from './payment-modal.module'

export default PaymentModalModule
